/**
 * This is dummy method you can apply to assure class will not be dropped
 * during tree shaking
 */
const dummy = false;
const buffer: any[] = [];

export function surviveTreeShaking(...args: any[]) {
    buffer.push(...args);
    if (dummy) {
        console.log(...args);
    }
}
